import * as z from "zod";
import { userFacingError } from "../authorization";
import { isFeatureFlagEnabled } from "../featureFlags";
import { PERSONAL_WORK_ACCESS_FLAG } from "../featureFlagNames";
import { zql } from "../generatedDrizzleSchema";
import { isPersonalWorkEnabled } from "../personalWork";
import { mutator } from "./mutator";

export const setPersonalWorkAccess = mutator({
  schema: z.object({ enabled: z.boolean(), previousEnabled: z.boolean() }),
  resolve: {},
  permissions: [
    { permission: "allow_all", scopeId: ({ ctx }) => ctx.tenantId },
  ],
  fn: async ({ tx, ctx, args }) => {
    if (
      !(await isFeatureFlagEnabled(tx, PERSONAL_WORK_ACCESS_FLAG, ctx.tenantId))
    ) {
      throw userFacingError("This feature is not available");
    }
    const tenant = await tx.run(zql.tenants.where("id", ctx.tenantId).one());
    if (!tenant || isPersonalWorkEnabled(tenant) !== args.previousEnabled) {
      throw userFacingError(
        "The setting changed since you loaded it — try again"
      );
    }
    const now = Date.now();
    await tx.mutate.tenants.update({
      id: ctx.tenantId,
      personalWorkDisabledAt: args.enabled ? null : now,
      updatedAt: now,
    });
  },
});
